import React from 'react';
import { atlasClient } from '../api/atlasClient';

interface RadarArticleCardProps {
  title: string;
  description?: string;
  imageId?: string;
  date?: string;
  onClick: () => void;
}

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const RadarArticleCard: React.FC<RadarArticleCardProps> = ({
  title,
  description,
  imageId,
  date,
  onClick,
}) => {
  const imageUrl = imageId ? atlasClient.getAssetUrl(imageId, { w: 640, q: 75 }) : null;

  return (
    <div className="radar-card" onClick={onClick}>
      {imageUrl && (
        <div className="radar-card-image">
          <img src={imageUrl} alt={title} loading="lazy" />
        </div>
      )}
      <div className="radar-card-body">
        <h3 className="radar-card-title">{title}</h3>
        {description && (
          <p className="radar-card-description">{description}</p>
        )}
        {date && (
          <div className="radar-card-date">{formatDate(date)}</div>
        )}
      </div>
    </div>
  );
};
